export default __webpack_public_path__ + "static/media/testimonial1.31ed548d.svg";